import { cookies } from 'lib/enums';
import Backbone from 'backbone';
import FacetViews from 'views/store/pages/categories/facet_views';
import { AsyncProductDropView } from 'views/store/pages/categories/async_product_drop_view';
import SocialBarView from 'views/store/common/social/social_bar';
import { UsabillaInlineCampaigns } from 'views/store/common/usabilla/_usabilla_inline_campaigns';
import jsCookie from 'js-cookie';
import { clientUtils } from 'app/client_utils';
import { GBISimilarSearchesView } from 'views/store/common/gbi/gbi_similar_searches';
import { InlineRecsView } from 'views/store/pages/categories/inline_recs_view.js';
import 'common/calc_widgets';
import gtmHelper from 'lib/helpers/gtm_helper';

export default Backbone.View.extend({
	el: '#page-content',

	events: {
		'click .js-narrow-results': '_showNarrowResultsUi',
		'click .js-view-change-button': '_handleChangeViewClick',
		'click .js-construct-facet-link, .js-content-facet-link': '_handleContentFacetClick',
		'click [data-review-link]': '_goToReviews',
		'click .js-product-link': '_trackDropClick',
		'click .js-expand-all-facets': '_expandAllFacets',
		'click .js-collapse-all-facets': '_collapseAllFacets',
		'click .js-finish-popover': '_finishesPopover',
		'click .js-search-relevance-answer': '_onSearchRelevanceClick'
	},

	initialize: function() {
		this.isAsyncProductDrops = window.dataLayer.isAsyncProductDrops;

		this._initChildViews();

		this.$viewButton = $('.js-view-change-button');
		this.$viewButtonContainer = $('.js-product-display-button');
		this.view = this.$viewButton.data('view');
		this.$searchTerm = this.$('.js-search-term');
		this.$searchCount = this.$('.js-search-result-count');
		this.$filterBoxButton = $('.js-narrow-results');
		this.$productGridContainer = $('.js-product-grid-container');
		this.$navTabs = this.$el.find('.nav-tabs a[data-toggle="tab"]');
		this.$navPanels = this.$el.find('.js-facet-banners .collapse');
		this.isMobileNarrowUiShown = false;
		this.allPopoverClassesOnPage = '.js-finish-popover';
		this._enableFilterButton();

		// in case someone removes this view, kill the childViews
		this.listenTo(this, 'removeyourself', this._onViewTriggerRemove.bind(this));

		$('.js-finish-popover').popover();

		if (this.$navTabs.length) {
			this._enablePersistantNavBanners(this.$navTabs, 'tab');
		} else if (this.$navPanels.length) {
			this._enablePersistantNavBanners(this.$navPanels, 'collapse');
		}

		// locate areas in page the urls need to be updated when tabs are changed.
		this.updateLinkAreas = $('#sort-by, #pagination, #results-per-page').find('a');
		clientUtils._initPopovers('.js-finish-popover');
		if (window.location.hash) {
			this._setHashToCurrentHref(this.updateLinkAreas, window.location.hash);
		}

		// setting this up here since we need access to the $productGridContainer
		if (this.isAsyncProductDrops) {
			this.childViews.asyncProductDropView = new AsyncProductDropView({
				parentView: this,
				siblingViews: {
					facetViews: this.childViews.facetViews,
					sortBy: this.childViews.sortBy,
					pagination: this.childViews.pagination
				},
				$productGridContainer: this.$productGridContainer
			});
		}

		this.listenTo(Backbone, 'body:click', this._handleSearchPageClick);
		this.listenTo(Backbone, 'accordion_list:toggle', this._handleExpandCollapseState.bind(this));
		this.listenTo(Backbone, 'universalLocation:changed', this._handleLocationChanged.bind(this));
	},

	_handleLocationChanged() {
		if (!window.dataLayer.isQuickShipEnabled) {
			return;
		}
		let queryParams;
		if (this.isAsyncProductDrops) {
			queryParams = this.childViews.asyncProductDropView.getAllQueryParams();
			this.childViews.asyncProductDropView.fetch({
				queryParams,
				view: this.view
			});
		} else {
			queryParams = this.getQueryParams().map(decodeURIComponent);
			const baseUrl = window.location.href.split('?')[0];
			const queryString = encodeURI(queryParams.join('&'));
			const newUrl = `${baseUrl}?${queryString}`;
			window.location.assign(newUrl);
		}
	},

	_finishesPopover: function(e) {
		const $currentTarget = $(e.currentTarget);
		$currentTarget.popover('toggle');
		e.stopPropagation();
	},

	_handleSearchPageClick: function(e) {
		const $targetElement = $(e.target);
		clientUtils._handleBodyClick($targetElement, this.allPopoverClassesOnPage);
	},

	_onViewTriggerRemove() {
		Object.keys(this.childViews).forEach((viewName) => {
			if (this.childViews[viewName] && this.childViews[viewName].remove) {
				// a trigger to make sure some deep nested child views remove themselves
				this.childViews[viewName].trigger('removeyourself');
				this.childViews[viewName].stopListening();
			}
		});
	},

	_getPaginationView() {
		return $('.js-pagination-component').data('componentView');
	},

	_getSortByView() {
		return $('#sort-by .js-select-box-component').data('componentView');
	},

	_initChildViews: function() {
		const isHandledClientSide = this.isAsyncProductDrops,
			startFacetListCollapsed = !window.BCOM.device.isDesktop;

		this.childViews = {
			facetViews: new FacetViews({
				facetListView: {
					enabled: true,
					el: '.js-facet-options',
					startCollapsed: startFacetListCollapsed
				},
				facetMenuView: {
					enabled: !window.BCOM.device.isDesktop
				},
				limitByFacetResultsView: {
					enabled: true,
					el: '.js-facet-limit-by-results'
				},
				facetBannerView: {
					enabled: true,
					el: '.js-facet-banners'
				},
				getQueryParams: this.getQueryParams.bind(this),
				onFacetsChange: this._onFacetViewsChange.bind(this)
			}),
			sortBy: this._getSortByView(),
			social: new SocialBarView()
		};

		this.childViews.sortBy && this.childViews.sortBy.setOptions({ onChange: this._onSortByChange.bind(this) });
		this.childViews.pagination = this._getPaginationView();
		this.childViews.pagination && this.childViews.pagination.setOptions({ isHandledClientSide });

		if (window.dataLayer.gbiSimilarSearches && this.$('.js-related-searches').length) {
			this.childViews.similarSearches = new GBISimilarSearchesView({
				el: this.$('.js-related-searches'),
				query: window.dataLayer.search && window.dataLayer.search.name
			});
			this.childViews.similarSearches.fetch();
		}

		if (window.BCOM.device.isMobile) {
			import('app/views/store/pages/search/back_to_top')
				.then((BackToTopView) => {
					this.childViews.backToTop = new BackToTopView();
				})
				.catch(window.clientErrorHandler);
		}

		if (window.dataLayer.canElevateSearchResults) {
			import('./elevate_views')
				.then(({ ElevateToolView, ElevateButtonsView }) => {
					this.childViews.elevateTool = new ElevateToolView();
					this.childViews.elevateButton = new ElevateButtonsView();
				})
				.catch(window.clientErrorHandler);
		}

		if (window.dataLayer.category && window.dataLayer.category.showQuickAdd) {
			import('views/store/common/quick_add/panel')
				.then((QuickAddView) => {
					this.childViews.quickAdd = new QuickAddView();
				})
				.catch(window.clientErrorHandler);
		}

		if (window.dataLayer.inlineRecommendationsId) {
			this.childViews.inlineRecs = new InlineRecsView({
				el: this.el,
				parentView: this,
				strategyId: window.dataLayer.inlineRecommendationsId,
				maxProducts: 3
			});
		}
	},

	_onFacetViewsChange: function(selectedFacetItems) {
		if (this.childViews.pagination) {
			this.childViews.pagination.model.set({
				activePage: 1
			});
		}

		if (this.isAsyncProductDrops) {
			this.childViews.asyncProductDropView.fetch();
		} else {
			const facetTrackingString = this.childViews.facetViews.getFacetTrackingString(),
				noSelectedFacets = Boolean(selectedFacetItems.length === 0),
				queryString = this.getQueryParams(noSelectedFacets).join('&'),
				newPathWithQuery = `${window.location.pathname}?${queryString}`,
				completePath = facetTrackingString ? `${newPathWithQuery}&${facetTrackingString}` : newPathWithQuery,
				newPath = queryString || facetTrackingString ? completePath : window.location.pathname,
				newPathWithHash = `${newPath}${window.location.hash}`;

			window.location.assign(newPathWithHash);

			jsCookie.set(cookies.LASTSEARCHPAGE, newPathWithHash, { path: '/' });
		}
	},

	_trackDropClick: function(event) {
		// Delegate inline recommendation click to child view.
		const isInlineRecommendation = $(event.currentTarget).closest('.js-inline-rec').length > 0;
		if (isInlineRecommendation) {
			this.childViews.inlineRecs.trackInlineRecClick(event);
			return;
		}

		// Track category or search product drop click.
		event.preventDefault();
		const eventName = window.dataLayer.search ? 'event138' : 'event157';
		const trackingData = {
			events: [eventName],
			linkName: 'Product Drop Click',
			redirect: event.currentTarget.href
		};

		const $productWrapper = $(event.currentTarget).closest('.js-product-wrapper');

		gtmHelper.fireEvent({
			event: 'product-click',
			ecommerce: {
				click: {
					actionField: {
						list: 'product listing page'
					},
					products: [
						gtmHelper.mapProductData({
							uniqueId: $productWrapper.data('trackingUniqueId'),
							finishName: $productWrapper.data('trackingFinishName'),
							manufacturer: $productWrapper.data('trackingBrand'),
							price: $productWrapper.data('trackingPrice'),
							// normally would pass stock count but that's not available in this case
							stockCount: Number($productWrapper.data('trackingOutOfStock')),
							image: $productWrapper.data('trackingImage'),
							productId: $productWrapper.data('trackingProductId'),
							position: $productWrapper.data('trackingPosition') + 1
						})
					]
				}
			}
		});

		Backbone.trigger('track:link', trackingData);
	},

	_showNarrowResultsUi: function() {
		if (!this.isMobileNarrowUiShown) {
			Backbone.trigger('omniture:clicktracking', 'mobile-show-facet-ui');
			this.isMobileNarrowUiShown = true;
		}
	},

	_getNextView: function() {
		return this.view === 'list' ? 'grid' : 'list';
	},

	_handleChangeViewClick: function() {
		if (this.isAsyncProductDrops) {
			this.childViews.asyncProductDropView.handleChangeViewClick();
		} else {
			window.location.assign(window.BCOM.util.updateURLParameters(window.location.href, 'view', this._getNextView(), true));
		}
	},

	_enableFilterButton: function() {
		this.$('.js-narrow-results').prop('disabled', false);
	},

	/**
	 * Sets an active bootstrap tab/collapse item given a hash e.g. #my_tab
	 * @param  {$} $navBanners - element(s) that are targeted by the specific bootstrap implementation (tab vs collapse)
	 * @param  {string} toggleType - the bootstrap ui type.. 'tab' or 'collapse'
	 * @param  {string} hash
	 */
	_setActiveBootstrapItem: function($navBanners, toggleType, hash) {
		if (!hash) {
			return;
		}

		const $targetEl = $navBanners.filter((index, element) => element.getAttribute('href') === hash);
		if (!$targetEl.length) {
			return;
		}

		if (toggleType === 'tab') {
			$targetEl.tab('show');
		} else if (toggleType === 'collapse') {
			if (!$targetEl.hasClass('in')) {
				// collapses open accordion panels before opening the target
				$navBanners
					.filter('.collapse.in')
					.collapse('hide')
					.end();
				$targetEl.collapse('show');
			}
		}
	},

	/**
	 * Set a hash e.g. #my_tab into the url of the browser
	 * @param  {string} hash
	 */
	_setActiveTabLocationHash: function(hash) {
		if (!hash || hash === '#' || window.location.hash === hash) {
			return;
		}

		this._setHashToCurrentHref(this.updateLinkAreas, hash);

		if (window.history.pushState) {
			// replaceState: tab selection should not hijack a user's back button
			window.history.replaceState(null, null, hash);
		} else {
			window.location.hash = hash;
		}
	},
	/**
	 * updates filter urls on the page to update hash value when it changes.
	 * @param {Array} elems
	 * @param {string} hash
	 */
	_setHashToCurrentHref: function($elemLinks, hash) {
		$elemLinks.each(function() {
			let elemUrl = $(this).attr('href');

			if (elemUrl.indexOf('#') > -1) {
				elemUrl = elemUrl.substr(0, elemUrl.indexOf('#'));
			}

			$(this).attr('href', `${elemUrl}${hash}`);
		});
	},

	/**
	 * Sets up persistent nav banner selections and targeting via external link
	 * @param  {$} $navBanners - element(s) that are targeted by the bootstrap implementation (tab or collapse)
	 * @param  {string} toggleType - the bootstrap implementation type.. 'tab' or 'collapse'
	 */
	_enablePersistantNavBanners: function($navBanners, toggleType) {
		if ($navBanners.length && (toggleType === 'tab' || toggleType === 'collapse')) {
			// check for pre-existing location.hash
			this._setActiveBootstrapItem($navBanners, toggleType, window.location.hash);
			// now bind to future tab changes and manually update location.hash
			$navBanners.on(`shown.bs.${toggleType}`, (e) => {
				const hash = toggleType === 'tab' ? e.currentTarget.href.split('#')[1] : e.target.id;
				this._setActiveTabLocationHash(`#${hash}`);
			});
			this._enableConstructPreview();
		}
	},

	/**
	 * Helper for construct preview.  Allows persistent tabs when creating the nav-banners.
	 */
	_enableConstructPreview: function() {
		// A check to see if it is loaded in an iframe.
		const isInFrame = window.self !== window.top;
		if (window.dataLayer.isLocalUser && window.parent && window.parent.postMessage && isInFrame) {
			// sonar flags the use of window postMessage regardless of NOSONAR so assigning	to variable
			const content = window.parent;
			content.postMessage('construct-preview-ready', window.dataLayer.constructUrl);
			const _handleMessage = function(event) {
				if (event && event.data === 'construct-reload') {
					window.location.reload(true);
				}
			};
			window.addEventListener('message', _handleMessage, false);
		}
	},

	_getSourceParamValue: function(query) {
		let sourceParamValue = window.BCOM.util.getQueryStringParameter('source', query);
		if (!sourceParamValue) {
			return '';
		}
		return this._returnPlaSourceQuery(sourceParamValue);
	},

	_returnPlaSourceQuery: function(source) {
		const plaMatchers = ['fb-allprod-ret_', 'gba', 'msn-pa_'];
		for (let matcher of plaMatchers) {
			if (source.indexOf(matcher) > -1) {
				return `source=${source}`;
			}
		}
		return '';
	},

	getQueryParams(noSelectedFacets) {
		const queryParams = this.childViews.facetViews.getFacetQueries(),
			source = this._getSourceParamValue(window.location.search),
			sortBy = this.childViews.sortBy.getValue(),
			dl = window.dataLayer;
		let pageSize = 0,
			page = 0;
		if (this.childViews.pagination) {
			pageSize = this.childViews.pagination.getPageSize();
			page = this.childViews.pagination.getActivePage();
		}
		if (source) {
			queryParams.push(source);
		}
		if (dl.search) {
			queryParams.push(`term=${dl.search.name}`);
		}
		if (noSelectedFacets) {
			return queryParams;
		}

		pageSize = pageSize || (dl.pagination && dl.pagination.pageSize) || 48;

		queryParams.push(`r=${pageSize}`);

		if (sortBy || dl.sortBy) {
			queryParams.push(`s=${sortBy || dl.sortBy.selectedValue}`);
		}

		if (page) {
			queryParams.push(`p=${page}`);
		}

		if (dl.categoryId) {
			queryParams.push(`categoryId=${dl.categoryId}`);
		} else if (dl.isPla) {
			queryParams.push(`term=application_string:"${dl.product.application}" type_string:"${dl.product.type}"`);
		}
		return queryParams;
	},

	_goToReviews(e) {
		e.preventDefault();
		const link = $(e.currentTarget).data('reviewLink');
		window.location.assign(link);
	},

	_expandAllFacets: function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		this.$el.find('.js-collapse-all-facets').removeClass('hide');
		this.$el.find('.js-expand-all-facets').addClass('hide');

		Backbone.trigger('facets:expand_all');
	},

	_collapseAllFacets: function(e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		this.$el.find('.js-collapse-all-facets').addClass('hide');
		this.$el.find('.js-expand-all-facets').removeClass('hide');

		Backbone.trigger('facets:collapse_all');
	},

	_handleExpandCollapseState: function() {
		const expandedFacetOptions = $('#facet-options')
			.find('.js-group')
			.filter((index, element) => {
				return $(element).hasClass('active');
			}).length;

		if (expandedFacetOptions) {
			this.$el.find('.js-collapse-all-facets').removeClass('hide');
			this.$el.find('.js-expand-all-facets').addClass('hide');
		} else {
			this.$el.find('.js-collapse-all-facets').addClass('hide');
			this.$el.find('.js-expand-all-facets').removeClass('hide');
		}
	},

	_onSortByChange: function(value) {
		window.BCOM.util.trackSortBy(value);
	},

	_onSearchRelevanceClick: function(event) {
		const answer = $(event.currentTarget).data('answer');
		if (answer) {
			const trackingData = {
				props: {
					prop25: answer
				},
				linkName: 'Usabilla Inline Search Campaign Answer'
			};
			Backbone.trigger('track:link', trackingData);

			UsabillaInlineCampaigns.openInlineSearchResultsCampaign(answer);
		}
	}
});
